// extracted by mini-css-extract-plugin
export default {"textHeading":"services_textHeading__EFWax","servText":"services_servText__hfrTg","mainDiv":"services_mainDiv__ysTDW"};